import { createSlice } from "@reduxjs/toolkit";

export const QrCodeSettingsSlice = createSlice({
  name: "QrOrderToken",
  initialState: {
    qrPanelToken: "",
    tableDetails: "" ,
    ChargeSettings: {},
    CartLength: 0,
    // Bumped whenever the order is refetched (e.g. the /place Refresh button) so
    // the header can re-pull tableDetail and keep the cart badge count in sync.
    orderRefreshNonce: 0,
  },
  reducers: {
    addQrPanelToken: (state, action) => {
      state.qrPanelToken = action.payload;
    },
    addTableDetails: (state, action) => {
      state.tableDetails = action.payload;
    },
    ChargeSettingsDetail : (state, action) => {
      state.ChargeSettings = action.payload;
    },
    SetCartLength : (state, action) => {
      state.CartLength = action.payload;
    },
    bumpOrderRefreshNonce : (state) => {
      state.orderRefreshNonce += 1;
    },
}
});

export const { addQrPanelToken, addTableDetails , ChargeSettingsDetail, SetCartLength, bumpOrderRefreshNonce } = QrCodeSettingsSlice.actions;
export default QrCodeSettingsSlice.reducer;
